import HeaderFooterLayout from '../js/layout/HeaderFooterLayout';
import SearchPage from '../js/search/SearchPage';

export default function () {
    return <SearchPage pageTitle="Søkeresultat" />;
}

export function StaticLayout() {
    return <HeaderFooterLayout className="page-search" robots="noindex,nofollow" page_title="Resultater" />;
}
